<template>
<div>
    <div v-if="!error" v-html="html"/>
    <div v-else>
      <div class="errorPage">
        <div class="container">
          <div class="error_wrapper">
            <div class="logo_box">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/top_line_logo.svg" alt="">
            </div>
            <div class="error">
              <h2>Ошибка</h2>
              <span>404</span>
              <p>Страница не существует или удалена</p>
            </div>
          </div>
          <router-link to="/" class="back_home">
            <span>Вернуться на главную</span>
          </router-link>
        </div>
      </div>
      <div class="main-image">
        <div class="main-image-image">
        </div>
        <div class="container">
          <div class="main-image__logo" v-if="auth.language !== 'dostavkauk'">
          </div>
        </div>
      </div>
      <div class="contacts__green-line" style="display: none">
        <div class="container">
          <h1 class="contacts__green-line-title" style="text-transform: none;"> {{title}}</h1>
        </div>
      </div>
      <div class="bottom-wrapper">
        <div class="line"></div>
      </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
import VRuntimeTemplate from 'v-runtime-template'
export default {
  name: 'articles',
  props: ['city', 'auth', 'user', 'modals'],
  data () {
    return {
      title: null,
      img: null,
      html: null,
      error: 0,
      link: null,
      meta: []
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: this.meta
    }
  },
  methods: {
    showModal (val) {
      this.$root.modalsData = this.link
      this.$root.modals = val
    }
  },
  created () {
    this.link = window.location.pathname
    axios.get('https://lk.when-hungry.com/mobile/get-page?link=' + window.location.pathname).then(response => {
      if (response.data.error) this.error = 1
      else {
        this.title = response.data.name
        this.html = '<div>' + response.data.html + '</div>'
      }
    })
  },
  watch: {
    error (val) {
      if (val) {
        this.title = 'Неизвестная страница'
        this.meta = [{ vmid: 'prerender-status-code', property: 'prerender-status-code', name: 'prerender-status-code', content: '404' }]
      }
    },
    $route (to, from) {
      this.link = window.location.pathname
      axios.get('https://lk.when-hungry.com/mobile/get-page?link=' + window.location.pathname).then(response => {
        if (response.data.error) this.error = 1
        else {
          this.title = response.data.name
          this.html = '<div>' + response.data.html + '</div>'
        }
      })
    }
  },
  components: {
    VRuntimeTemplate
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/article.vue